import { ReactElement, useState, useEffect } from 'react';
import { PlaceType } from 'components/UI/NewLocationAutocomplete';
import NewLocationAutocomplete from 'components/UI/NewLocationAutocomplete';
import CTA from 'components/UI/Cta';
import { IComponentDoctorFinderFields, IPageLocationFields } from 'types/contentful';
import RichText from 'components/UI/Richtext';
import { useRouter } from 'next/router';

export interface DoctorFinderProps extends IComponentDoctorFinderFields {
  locations?: IPageLocationFields[];
  initValue?: PlaceType | null;
  freshPaintToken: string | null | undefined;
  className?: string;
}

export default function DoctorFinder({
  initValue,
  freshPaintToken,
  className,
  description,
  ctA,
  heading,
  subHeading,
  backgroundColor,
}: DoctorFinderProps): ReactElement {
  const [background, setBackground] = useState<string>('bg-white');

  useEffect(() => {
    if (backgroundColor && backgroundColor === 'Muted') {
      setBackground('bg-muted');
    }
  }, [backgroundColor]);

  const router = useRouter();

  const onFindClick = (location: PlaceType | null): void => {
    router.push(
      {
        pathname: '/locations',
        query: { placeId: location?.place_id },
      },
      '/locations', // This is the URL that will be shown to the user
      { shallow: true }
    );
  };

  return (
    <div className="ecp-my">
      <div
        className={`px-6 py-10 md:py-20 text-center space-y-6 md:space-y-8 text-primary-actual ${className} ${background}`}
      >
        <div>
          <h3 className="text-new-34 lg:text-4xl lg:leading-new-43 text-primary-actual">
            {heading}
          </h3>
        </div>
        <div className="w-full md:w-3/4 lg:w-2/3 mx-auto space-y-6 md:space-y-8">
          <div>
            {subHeading && (
              <RichText
                document={subHeading}
                classNames="text-lg text-primary-actual font-light px-2 text-left md:text-center center_richtext_content"
              />
            )}
          </div>
          <div className="w-full mx-auto">
            <NewLocationAutocomplete
              className={`${background}`}
              onFindClick={onFindClick}
              initValue={initValue}
              freshPaintToken={freshPaintToken}
              hideEndAdornment={true}
            />
          </div>
          {description && (
            <RichText
              document={description}
              classNames="text-lg text-primary-actual font-light px-2 text-left md:text-center center_richtext_content"
            />
          )}
          <div className="flex flex-wrap justify-self-center flex-row md:justify-center gap-3 md:gap-4">
            {ctA?.map((x, index) => (
              <div key={index}>
                <CTA {...x.fields} classNames="text-primary-actual button-text bg-white" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
